import {
  LocalStorageKeys,
  LocalStorageService,
  formatDateForRequest,
  getDatePlusThreeMonth,
  post,
} from '../../../utils';
import { useCallback, useEffect, useMemo } from 'react';

import type { TApptStatus } from '../../../utils/types';
import { apptListAtom } from '../../../atoms';
import { useRecoilState } from 'recoil';

export function useData() {
  const [apptList, setApptList] = useRecoilState(apptListAtom);

  const requestData = useMemo(() => {
    const today = new Date();
    return {
      dateRange: {
        from: `${formatDateForRequest(today)} 00:00`,
        to: `${getDatePlusThreeMonth(today)} 23:59`,
      },
      status: ['PENDING', 'APPROVED'],
    };
  }, []);

  const getApptList = useCallback(async () => {
    if (!LocalStorageService.getItem(LocalStorageKeys.AccessToken)) return;
    
    const { data, error } = await post('LIST_APPOINTMENT', requestData);

    if (error) {
      return;
    } 

    if (data) {
      const responseData = data as any; 

      const approvedApptsWithStatus = (responseData.APPROVED || []).map((appt: any) => ({
        ...appt,
        type: 'APPROVED' as TApptStatus,
      }));

      const pendingApptsWithStatus = (responseData.PENDING || []).map((appt: any) => ({
        ...appt,
        type: 'PENDING' as TApptStatus,
      }));

      const allAppointments = [...approvedApptsWithStatus, ...pendingApptsWithStatus];

      const sortedApptList = allAppointments.sort((a, b) => {
        if (!a.startDate || !b.startDate) return 0;
        
        const [aDate, aTime] = a.startDate.split(' ');
        const [bDate, bTime] = b.startDate.split(' ');

        return new Date(`${aDate}T${aTime}:00Z`).getTime() - new Date(`${bDate}T${bTime}:00Z`).getTime();
      });

      setApptList(sortedApptList);
    }
  }, [requestData, setApptList]);

  useEffect(() => {
    getApptList();
  }, [getApptList]);

  return { apptList };
}